import React from 'react';
import SatInput from '@components/common/satUI/SatInput';
import SatDateInput from '@components/common/satUI/SatDateInput';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import SatModal from '@components/common/satUI/SatModal';
import { isEmptyString } from '@common/utils';
import { INSURANCE_COMPARE_VALID_STATUS } from '@common/constants';

const InputConstractStatusDate = ({
  type,
  statusKey,
  dateKey,
  status,
  date,
  isErrorVisible,
  onChange,
}) => {
  const {
    isOn: isShowModal,
    on: showModal,
    off: hideModal,
  } = $hooks.useToggler();

  const statusOptions = [
    '심사중',
    '정상',
    '해약(해지)',
    '실효',
    '청약철회',
    '품질보증해지',
  ];

  const inputKey = type === 'status' ? statusKey : dateKey;
  const inputValue = type === 'status' ? status : date;
  const isValidInput =
    type === 'date'
      ? INSURANCE_COMPARE_VALID_STATUS.includes(status) || !isEmptyString(date)
      : !isEmptyString(inputValue);

  return (
    <>
      <SatInput
        noFocus
        value={inputValue}
        onClick={showModal}
        onDelete={() => onChange(inputKey, '')}
      />
      <SatValidationErrMsg
        type="error"
        visible={isErrorVisible && !isValidInput}
        message="값을 입력해주세요."
      />

      <SatModal
        isPortal
        type="newInfo"
        visible={isShowModal}
        setVisible={hideModal}
      >
        <header className="modal-header">
          <h3 className="layer-tit2">계약상태 및 계약상태발생일</h3>
        </header>

        <button
          type="button"
          className="btn-layer-close modal-close"
          onClick={hideModal}
        >
          닫기
        </button>

        <div className="cont">
          <ul className="dot-type type-m">
            <li>계약상태 및 계약상태 발생일을 작성하시기 바랍니다.</li>
            <li className="red">
              계약상태 발생일은 해약(해지), 실효 선택시만 반드시 입력하시기
              바랍니다.
            </li>
          </ul>

          <div className="insu-box">
            <div className="txt-question mgt-10">
              <p className="tit-mini">계약상태 선택</p>
            </div>
          </div>

          <div className="check-box">
            {statusOptions.map((statusOption, index) => (
              <div key={index} className="check-wrap">
                <input
                  id={`status-${index}`}
                  type="radio"
                  checked={statusOption === status}
                  onChange={() => onChange(statusKey, statusOption)}
                />
                <label htmlFor={`status-${index}`}>{statusOption}</label>
              </div>
            ))}
          </div>

          <div className="insu-box">
            <div className="txt-question">
              <p className="tit-mini">계약상태일자 선택</p>
            </div>
          </div>

          <SatDateInput
            title="계약상태일자"
            placeholder="YYYY-MM-DD"
            dateFormat="yyyy-MM-dd"
            splitter="-"
            dateLength={8}
            value={date}
            onChange={value => onChange(dateKey, value)}
          />
        </div>

        <div className="layer-footer">
          <button
            type="button"
            className="btn-s blue btn-wide modal-close"
            onClick={hideModal}
          >
            저장
          </button>
        </div>
      </SatModal>
    </>
  );
};

export default InputConstractStatusDate;
